export default "__VITE_ASSET__HoPppLs4__"